import clsx from "clsx";

export type ActionMenuItemOption = {
    label: string;
    to?: string;
    disabled?: boolean;
    onClick?: () => void;
};

type ActionMenuOptionsProps = {
    option: ActionMenuItemOption;
};

const ActionMenuOption = ({ option }: ActionMenuOptionsProps) => {
    return (
        <button
            disabled={option.disabled}
            onClick={option.onClick}
            className={clsx(
                "flex items-center px-4 py-3 gap-3 hover:bg-surface-light-1 transition-colors w-full",
                { "opacity-40": option.disabled }
            )}
        >
            {option.label}
        </button>
    );
};

export default ActionMenuOption;
